import { WEBVIEW_DISABLED_INPUT, WEBVIEW_SET_FOCUS_INPUT } from "./const";

const isInputDisabled = data => dispatch => {
  dispatch({ type: WEBVIEW_DISABLED_INPUT, data });
};

const setFocus = data => dispatch => {
  dispatch({ type: WEBVIEW_SET_FOCUS_INPUT, data });
};

export default {
  isInputDisabled,
  setFocus,
};
